import produce from "immer";
import {
  GET_DASHBOARD_SUMMARY,
  GET_DASHBOARD_SUMMARY_SUCCESS,
  GET_DASHBOARD_SUMMARY_ERROR,
} from "./actionTypes";

const initialState = {
  summary: null,
  loading: false,
  error: "",
};

const dashboardReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_DASHBOARD_SUMMARY:
      return { ...state, loading: true, error: "" };

    case GET_DASHBOARD_SUMMARY_SUCCESS:
      return { ...state, summary: payload.data, loading: false };

    case GET_DASHBOARD_SUMMARY_ERROR:
      return { ...state, error: payload, loading: false };

    default:
      return state;
  }
});

export default dashboardReducer;
